import type { PaletteOptions } from '@mui/material';

export const palette: PaletteOptions = {
  primary: {
    main: '#458FFF',
    contrastText: '#000',
  },
  secondary: {
    main: '#458FFF',
    contrastText: '#fff',
  },
};